<div mat-dialog-title class="dialog-info" closeOnEscape>
    <label class="dialogTitle">
        {{'ESCALATION' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="p-0-10">
    <div class="col-md-12 pr-0">
        <mat-dialog-content class="contentPadding">
            <div class="checkbox-container">
                <div class="checkbox-row">
                    <mat-checkbox color="primary" (change)="isIndividualEscalationApplicable($event)" class="custom-checkbox" [(ngModel)]="escalationEnabled" [disabled]="isCollaborativeNotEdit || isEstimateSapSubmitted || isOutOfEscalationRange">
                        {{'ESCALATE' | translate}}
                        <span>{{escalationDialogData.sectionLabel | translate }}</span>&nbsp;
                        @if (escalationDialogData.escalationType === 'Labor') {
                            <span>{{'LABOR' | translate}}</span>
                        }
                    </mat-checkbox>
                    <div>
                        <div class="cost-labels-container">
                            <p>{{'COST' | translate}}:</p>
                            <p>{{escalationDialogData.escalationData.baseCost | multilingualCurrency}}</p>
                        </div>
                    </div>
                </div>
                <div class="checkbox-row">
                    <mat-checkbox color="primary" class="custom-checkbox" [(ngModel)]="applyToAll" [disabled]="isCollaborativeNotEdit || isEstimateSapSubmitted || isOutOfEscalationRange">
                        <span *ngIf="escalationDialogData.escalationType === 'Material'">{{'APPLY_TO_ALL_MATERIAL_CATEGORIES' | translate}}</span>
                        <span *ngIf="escalationDialogData.escalationType === 'Labor'">{{'APPLY_TO_ALL_LABOR_CATEGORIES' | translate}}</span>
                    </mat-checkbox>
                    <div>
                        <div class="cost-labels-container">
                            <p>{{'ESCALATED' | translate}}:</p>
                            <p>{{totalEscalatedCost | multilingualCurrency}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <div class="form-group" [formGroup]="escalationRatesFormGroup">
                    <table mat-table [dataSource]="escalationDataSource">
                        <ng-container matColumnDef="escalationPeriodName">
                            <th mat-header-cell *matHeaderCellDef   > 
                                {{'ESCALATION_PERIOD' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination" [ngClass]="{'noNameWarrantyPeriod': !element.escalationPeriodName}"> 
                                {{element.escalationPeriodName | translate}} 
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="FIRST_YEAR">
                            <th mat-header-cell *matHeaderCellDef   > 
                                {{'ONE' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination space-between"> 
                                <ng-container *ngIf="element.escalationPeriodName !== 'PERCENTAGE'; else FIRST_YEAR">
                                    {{element.FIRST_YEAR}}
                                </ng-container>
                                <ng-template #FIRST_YEAR>
                                    <mat-form-field appearance="outline" class="form-field-size" [class.readonly-field]="isEstimateSapSubmitted || disabledYears[0]">
                                        <input matInput [appNumericMask]="percentageConfig" [readonly]="isEstimateSapSubmitted" formControlName="firstYearEscalation" inputmode="numeric" placeholder="Enter value" class="form-input">
                                    </mat-form-field> 
                                </ng-template>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="SECOND_YEAR">
                            <th mat-header-cell *matHeaderCellDef   > 
                                {{'TWO' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination space-between "> 
                                <ng-container *ngIf="element.escalationPeriodName !== 'PERCENTAGE'; else SECOND_YEAR">
                                    {{element.SECOND_YEAR}}
                                </ng-container>
                                <ng-template #SECOND_YEAR>
                                    <mat-form-field appearance="outline" class="form-field-size" [class.readonly-field]="isEstimateSapSubmitted || disabledYears[1]">
                                        <input matInput [appNumericMask]="percentageConfig" [readonly]="isEstimateSapSubmitted" formControlName="secondYearEscalation" inputmode="numeric" placeholder="Enter value" class="form-input">
                                    </mat-form-field> 
                                </ng-template>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="THIRD_YEAR">
                            <th mat-header-cell *matHeaderCellDef   > 
                                {{'THREE' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination space-between "> 
                                <ng-container *ngIf="element.escalationPeriodName !== 'PERCENTAGE'; else THIRD_YEAR">
                                    {{element.THIRD_YEAR}}
                                </ng-container>
                                <ng-template #THIRD_YEAR>
                                    <mat-form-field appearance="outline" class="form-field-size" [class.readonly-field]="isEstimateSapSubmitted || disabledYears[2]">
                                        <input matInput [appNumericMask]="percentageConfig" [readonly]="isEstimateSapSubmitted" formControlName="thirdYearEscalation" inputmode="numeric" placeholder="Enter value" class="form-input">
                                    </mat-form-field> 
                                </ng-template>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="FOURTH_YEAR">
                            <th mat-header-cell *matHeaderCellDef   > 
                                {{'FOUR' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination space-between "> 
                                <ng-container *ngIf="element.escalationPeriodName !== 'PERCENTAGE'; else FOURTH_YEAR">
                                    {{element.FOURTH_YEAR}}
                                </ng-container>
                                <ng-template #FOURTH_YEAR>
                                    <mat-form-field appearance="outline" class="form-field-size" [class.readonly-field]="isEstimateSapSubmitted || disabledYears[3]">
                                        <input matInput [appNumericMask]="percentageConfig" [readonly]="isEstimateSapSubmitted" formControlName="fourthYearEscalation" inputmode="numeric" placeholder="Enter value" class="form-input">
                                    </mat-form-field> 
                                </ng-template>
                            </td>
                        </ng-container>
    
                        <ng-container matColumnDef="FIFTH_YEAR">
                            <th mat-header-cell *matHeaderCellDef   > 
                                {{'FIVE' | translate}} 
                            </th>
                            <td mat-cell *matCellDef="let element" class="tableDefination space-between "> 
                                <ng-container *ngIf="element.escalationPeriodName !== 'PERCENTAGE'; else FIFTH_YEAR">
                                    {{element.FIFTH_YEAR}}
                                </ng-container>
                                <ng-template #FIFTH_YEAR>
                                    <mat-form-field appearance="outline" class="form-field-size" [class.readonly-field]="isEstimateSapSubmitted || disabledYears[4]">
                                        <input matInput [appNumericMask]="percentageConfig" [readonly]="isEstimateSapSubmitted" formControlName="fifthYearEscalation" inputmode="numeric" placeholder="Enter value" class="form-input">
                                    </mat-form-field> 
                                </ng-template>
                            </td>
                        </ng-container>
    
                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="rowHeight"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="rowHeight tableDefination"></tr>
                    </table>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <div class="warranty-dates-container">
                <div class="warranty-dates-label">
                    <p class="date-width">{{'ESCALATION_START_DATE' | translate}}:</p>
                    <p>{{formattedStartDate }}</p>
                </div>
                <div class="warranty-dates-label">
                    <p class="date-width">{{'ESCALATION_END_DATE' | translate}}:</p>
                    <p>{{formattedEndDate}}</p>
                </div>
                
            </div>
            <div>
                <button class="openCloseBtn" mat-raised-button color="primary">{{'NAVBAR_HELP' | translate}}</button>
                <button class="openCloseBtn" [disabled]="!isValidEscalation || isCollaborativeNotEdit || isEstimateSapSubmitted || isOutOfEscalationRange" mat-raised-button color="primary" (click)="onOk()">{{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}</button>
                <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>{{'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate}}</button>
            </div>
        </mat-dialog-actions>
    </div>
</div>